// External libraries
import gql from 'graphql-tag';

export const CALCULATE_SHIPPING_AND_TAXES_QUERY = gql`
  query CalcShippingAndTaxesQuery(
    $token: String!
    $locale: LocaleInput!
    $shippingAddress: AddressInput!
  ) {
    calculateShippingAndTaxes(
      token: $token
      locale: $locale
      shippingAddress: $shippingAddress
    ) {
      charges {
        shipping {
          id
          type
          isDefaultShippingOption
          hasInsurance
          label
          shippingAmount {
            currencyCode
            currencyFormatSymbolISOCurrency
            currencyValue
          }
          insuranceAmount {
            currencyCode
            currencyFormatSymbolISOCurrency
            currencyValue
          }
        }
        tax {
          item {
            currencyCode
            currencyFormatSymbolISOCurrency
            currencyValue
          }
          total {
            currencyCode
            currencyFormatSymbolISOCurrency
            currencyValue
          }
        }
      }
      isShippingRegionSupported
      shippingOptionsSource
      isTaxOnShippingRequired
      shouldShowShippingOptions
    }
  }
`;
